export default {
  info,
  warn,
  error
}

function info (tag, message) {
  console.info(`${new Date().toISOString()} ${tag}: ${message}`)
}

function warn (tag, message) {
  console.warn(`${new Date().toISOString()} ${tag}: ${message}`)
}

function error (tag, message) {
  console.error(`${new Date().toISOString()} ${tag}: ${message}`)
}
